module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm_title"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("TABLE OF CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/08_ch1"
    }
  }, [_c('b', [_vm._v("Middle Management Hell")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch1#sec_1"
    }
  }, [_vm._v("Are You Stuck In Middle Management Hell?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch1#sec_2"
    }
  }, [_vm._v("1. Stress, Stress And More Stress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch1#sec_3"
    }
  }, [_vm._v("2. Lack Of Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch1#sec_4"
    }
  }, [_vm._v("3. Gaps Between Career And Personal Aspirations 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch1#sec_5"
    }
  }, [_vm._v("4. Career Plateau")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch1#sec_6"
    }
  }, [_vm._v("5. Financial Constraints")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch1#sec_7"
    }
  }, [_vm._v("6. Fear Of Layoffs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch1#sec_8"
    }
  }, [_vm._v("7. Work Overload")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch1#sec_9"
    }
  }, [_vm._v("8. Outdated Competencies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch1#sec_10"
    }
  }, [_vm._v("9. Impersonal Workplace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ch1#sec_11"
    }
  }, [_vm._v("10. Distracting Communication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('a', {
    attrs: {
      "href": "#/09_ch2"
    }
  }, [_c('b', [_vm._v("Adversities")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/10_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Blueprint for Success")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/10_ch3#sec_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inner Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/10_ch3#sec_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outer Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part"
  }, [_c('span', {
    attrs: {
      "href": "#/11_part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part I: Inner leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Intention")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/12_ch4#sec_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transform From Manager To Leader")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/12_ch4#sec_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Set Personal Goals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/12_ch4#sec_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Achieve Your Goals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/12_ch4#sec_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visualize Your Game")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/12_ch4#sec_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exchange Arrogance For Humility")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/12_ch4#sec_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stay In Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/12_ch4#sec_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dare To Change")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/12_ch4#sec_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attract Success Effectively")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/12_ch4#sec_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Thought And The Law Of Attraction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Expansiveness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch5#sec_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lead Yourself Before You Lead Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch5#sec_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Expand Beyond Expertise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch5#sec_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lead With Adaptive Skills")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch5#sec_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enhance Your Strengths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch5#sec_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Engage The Whole Brain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch5#sec_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unleash Your Creative Power")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch5#sec_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Express Emotions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/13_ch5#sec_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stick To The Magic Number")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Effectiveness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch6#sec_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Become More Effective")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch6#sec_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Focus On 2.5%")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch6#sec_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reduce Emails")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch6#sec_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boost Digital Effectiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch6#sec_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Engage In Exponential Change")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch6#sec_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Become A Linchpin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch6#sec_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modify Your Dna")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch6#sec_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Embrace Abundance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_part"
  }, [_c('span', {
    attrs: {
      "href": "#/15_part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: Outer leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Dialogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7#sec_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Master Communication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7#sec_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discuss Before You Decide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7#sec_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confront Colleagues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7#sec_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acquire 7 Confrontation Rules")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7#sec_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be Ready For The Unexpected")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7#sec_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transform Individuals Into Teams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7#sec_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Promote Change")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7#sec_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Engage To Get Commitment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/16_ch7#sec_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conduct Reality Checks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7#sec_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Navigate The Informal Organization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7#sec_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step Away From The Power Point")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7#sec_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pay Attention")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Decision")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch8#sec_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decide How To Decide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch8#sec_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manage Your Perception")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch8#sec_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Develop Influential Competence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch8#sec_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take A Stand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch8#sec_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Persuade In The Boardroom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch8#sec_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Achieve Clarity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch8#sec_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Consensus Of Commitment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch8#sec_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discern Before You Decide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Action")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch9#sec_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hire Your Replacement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch9#sec_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get Your Hands On")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch9#sec_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Execute To Turn Goals Into Results")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch9#sec_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Embrace Accountability")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch9#sec_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stop Multi-Tasking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch9#sec_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be Successful In Uncertain World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch9#sec_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be An Intrapreneur")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch9#sec_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Establish Rituals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/19_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Pinnacle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/20_epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/21_bibl",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/22_about",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-080ee668","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_cont.vue
// module id = 75
// module chunks = 0